
export const inputMap = [
    'question',
    'starter',
    'Y',
    'YY',
    'YN',
    'YYY',
    'YYN',
    'YNY',
    'YNN',
    'YYYY',
    'YYYN',
    'YYNY',
    'YYNN',
    'YNYY',
    'YNYN',
    'YNNY',
    'YNNN',
    'N',
    'NY',
    'NN',
    'NYY',
    'NYN',
    'NNY',
    'NNN',
    'NYYY',
    'NYYN',
    'NYNY',
    'NYNN',
    'NNYY',
    'NNYN',
    'NNNY',
    'NNNN',
] 

export const defaultInputs = {
    'question':'',
    'starter':'',
    'Y':'',
    'YY':'',
    'YN':'',
    'YYY':'',
    'YYN':'',
    'YNY':'',
    'YNN':'',
    'YYYY':'',
    'YYYN':'',
    'YYNY':'',
    'YYNN':'',
    'YNYY':'',
    'YNYN':'',
    'YNNY':'',
    'YNNN':'',
    'N':'',
    'NY':'',
    'NN':'',
    'NYY':'',
    'NYN':'',
    'NNY':'',
    'NNN':'',
    'NYYY':'',
    'NYYN':'',
    'NYNY':'',
    'NYNN':'',
    'NNYY':'',
    'NNYN':'',
    'NNNY':'',
    'NNNN':'',
}